// extracted by mini-css-extract-plugin
module.exports = {"Attachments":"Attachments_Attachments__2D2U_","AriaDescription":"Attachments_AriaDescription__2Vo85","ForceVisible":"Attachments_ForceVisible__Csl8n"};